/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OutputContentByIdQueryVariables = Types.Exact<{
  contentIds:
    | ReadonlyArray<Types.Scalars["OutputContentId"]["input"]>
    | Types.Scalars["OutputContentId"]["input"];
}>;

export type OutputContentByIdQuery = {
  readonly __typename: "Query";
  readonly safeOutputContentById: ReadonlyArray<
    | {
        readonly __typename: "OutputContent";
        readonly id: c.OutputContentId;
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly mimeType: string;
        readonly contents: string;
        readonly requiresLazyLoad: boolean;
      }
    | {
        readonly __typename: "OutputContentNotFound";
        readonly id: c.OutputContentId;
      }
  >;
};

export const OutputContentByIdDocument = /*#__PURE__*/ gql`
  query OutputContentById($contentIds: [OutputContentId!]!) {
    safeOutputContentById(contentIds: $contentIds) {
      ... on OutputContent {
        id
        createdDate
        updatedDate
        deletedDate
        revision
        mimeType
        contents
        requiresLazyLoad
      }
      ... on OutputContentNotFound {
        id
      }
    }
  }
`;

/**
 * __useOutputContentByIdQuery__
 *
 * To run a query within a React component, call `useOutputContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutputContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutputContentByIdQuery({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useOutputContentByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  > &
    (
      | { variables: OutputContentByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  >(OutputContentByIdDocument, options);
}
export function useOutputContentByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  >(OutputContentByIdDocument, options);
}
// @ts-ignore
export function useOutputContentByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OutputContentByIdQuery,
  OutputContentByIdQueryVariables
>;
export function useOutputContentByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OutputContentByIdQuery,
        OutputContentByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OutputContentByIdQuery | undefined,
  OutputContentByIdQueryVariables
>;
export function useOutputContentByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OutputContentByIdQuery,
        OutputContentByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OutputContentByIdQuery,
    OutputContentByIdQueryVariables
  >(OutputContentByIdDocument, options);
}
export type OutputContentByIdQueryHookResult = ReturnType<
  typeof useOutputContentByIdQuery
>;
export type OutputContentByIdLazyQueryHookResult = ReturnType<
  typeof useOutputContentByIdLazyQuery
>;
export type OutputContentByIdSuspenseQueryHookResult = ReturnType<
  typeof useOutputContentByIdSuspenseQuery
>;
export type OutputContentByIdQueryResult = Apollo.QueryResult<
  OutputContentByIdQuery,
  OutputContentByIdQueryVariables
>;
